export function getExerciseResultsFromZone(zone, resultsData) {
  const resultsFromZone = resultsData.filter(i => Array.isArray(i.zone)
    ? i.zone.includes(zone) || (zone === 1 && i.zone.length === 0)
    : i.zone === zone || (zone === 1 && !i.zone)
  );
  return resultsFromZone.sort((a, b) => a.resultOrder - b.resultOrder);
}
